import { z } from "zod";
import type { ModuleFeedback } from "./types";

namespace ApiSchema {
  export const Endpoints: z.ZodType<ModuleFeedback.Api.Endpoints> = z.object({
    submit: z.string(),
    decline: z.string(),
  });

  export const SubmitRequest: z.ZodType<ModuleFeedback.Api.SubmitRequest> =
    z.object({
      rate: z.number().optional(),
      message: z.string().optional(),
    });

  export const SubmitResponse: z.ZodType<ModuleFeedback.Api.SubmitResponse> =
    z.literal(null);
}

namespace RatingSchema {
  export const Label: z.ZodType<ModuleFeedback.Rating.Label> = z.object({
    min: z.string(),
    max: z.string(),
  });

  export const Rating: z.ZodType<ModuleFeedback.Rating.Rating> = z.object({
    scale: z.array(z.number()),
    label: Label,
  });
}

export namespace ModuleFeedbackSchema {
  export namespace Api {
    export const Endpoints: z.ZodType<ModuleFeedback.Api.Endpoints> = z.object({
      submit: z.string(),
      decline: z.string(),
    });
  }

  export const Config: z.ZodType<ModuleFeedback.Config> = z.object({
    api: ApiSchema.Endpoints,
    title: z.string(),
    text: z.string(),
    rating: RatingSchema.Rating,
    input: z.object({
      placeholder: z.string(),
    }),
    submitBtn: z.object({
      text: z.string(),
    }),
    closetBtn: z.object({
      text: z.string(),
    }),
    success: z.object({
      title: z.string(),
      text: z.string(),
    }),
  });
}
